import type { SearchTidLinkedAccountsQuery } from "@/api/graphql/types/graphql";
import {
  getDateFromTimestampInSeconds,
  sanitizeTimestamp,
} from "@/utils/date/utils";

import type { TidLinkedAccountItem } from "./types";

export const fromApiToTidLinkedAccounts = (
  response: SearchTidLinkedAccountsQuery,
): TidLinkedAccountItem[] => {
  if (!response.BillingMsSearchTidLinkedAccounts?.data) {
    return [];
  }

  return response.BillingMsSearchTidLinkedAccounts.data.map((link) => ({
    id: link.id,
    linkedAccountId: link.linkedAccountId,
    accountNumber: link.LinkedAccountIdData?.number ?? "",
    companyName: link.LinkedAccountIdData?.IdData?.name ?? "",
    type: link.TypeIdData?.code ?? "",
    updatedTs: getDateFromTimestampInSeconds(sanitizeTimestamp(link.updatedTs)),
  }));
};
